import axios from "axios";
import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Dropdown } from "react-bootstrap";

import LanguagesButton from "../components/languageButton/LanguagesButton.jsx";
import "./navbar-signal.css";

// "" (chaine vide) = meme origine en prod -> ?? et non || (|| ecraserait la chaine vide)
const BASE_URL = process.env.REACT_APP_API_BASE_URL ?? "http://127.0.0.1:8000";

const NavBar = (props) => {
  const { t } = useTranslation();
  const { isLoggedIn, setShowModal, setIsLoggedIn, balance } = props;
  const user_id = localStorage.getItem("id");
  const [open, setOpen] = useState(false);
  const [theme, setTheme] = useState(() => localStorage.getItem("theme") || "light");

  const toggleTheme = () => {
    const next = theme === "dark" ? "light" : "dark";
    setTheme(next);
    localStorage.setItem("theme", next);
    if (next === "dark") {
      document.documentElement.setAttribute("data-theme", "dark");
    } else {
      document.documentElement.removeAttribute("data-theme");
    }
  };

  const amount = (Math.round((Number(balance) || 0) * 100) / 100).toFixed(2);

  const logout = () => {
    axios({
      method: "get",
      url: `${BASE_URL}/user/signout`,
      headers: { Authorization: `Token ${localStorage.getItem("token")}` },
    })
      .then(() => {})
      .catch((err) => console.log(err));
    setIsLoggedIn(false);
    localStorage.removeItem("token");
    window.location.reload(false);
  };

  const links = [
    { to: `/`, label: t("overview.buy-number"), end: true },
    { to: `/rent`, label: t("overview.rent-tab") },
    { to: `/free-numbers`, label: t("overview.freenum") },
    ...(isLoggedIn ? [{ to: `/order-list`, label: t("overview.orders-tab") }] : []),
    { to: `/api-docs`, label: t("overview.api-1") },
    { to: `/help`, label: t("overview.faq-1") },
  ];

  return (
    <nav className="ds-nav">
      <div className="ds-nav__inner">
        <div className="ds-nav__left">
          <NavLink className="brand-logo" to={`/`} aria-label="2FASMS" onClick={() => setOpen(false)}>
            <span className="b-2fa">2FA</span>
            <span className="b-sms">SMS</span>
          </NavLink>
          <div className="ds-nav__links">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.end}
                className="ds-navlink"
              >
                {l.label}
              </NavLink>
            ))}
          </div>
        </div>

        <div className="ds-nav__right">
          <button
            className="ds-theme"
            aria-label={theme === "dark" ? t("signal.theme-to-light") : t("signal.theme-to-dark")}
            title={theme === "dark" ? t("signal.theme-light") : t("signal.theme-dark")}
            onClick={toggleTheme}
          >
            {theme === "dark" ? (
              /* soleil */
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <circle cx="12" cy="12" r="4" />
                <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
              </svg>
            ) : (
              /* lune */
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" />
              </svg>
            )}
          </button>
          <div className="ds-nav__lang">
            <LanguagesButton />
          </div>

          {isLoggedIn ? (
            <>
              <NavLink className="ds-balance" to={`/deposit`}>
                <span className="ds-balance__label">{t("signal.nav-balance")}</span>
                <span className="ds-balance__amt">${amount}</span>
              </NavLink>
              <NavLink className="ds-btn ds-btn--primary ds-nav__deposit" to={`/deposit`}>
                {t("overview.deposit")}
              </NavLink>
              <Dropdown align="end">
                <Dropdown.Toggle as="button" className="ds-avatar" aria-label={t("signal.account")}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="8" r="4" /><path d="M4 21c0-4 4-6 8-6s8 2 8 6" /></svg>
                </Dropdown.Toggle>
                <Dropdown.Menu className="ds-menu">
                  <Dropdown.Item as="span" className="ds-menu__id">{t("signal.user-id", { id: user_id })}</Dropdown.Item>
                  <Dropdown.Item as={NavLink} to={`/change-password`}>{t("overview.settings")}</Dropdown.Item>
                  <Dropdown.Divider />
                  <Dropdown.Item as="span" onClick={logout}>{t("overview.log-out")}</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </>
          ) : (
            <button className="ds-btn ds-btn--primary" onClick={() => setShowModal(true)}>
              {t("overview.sign-in")}
            </button>
          )}

          <button
            className="ds-nav__toggle"
            aria-label={t("signal.menu")}
            onClick={() => setOpen((v) => !v)}
          >
            <span></span><span></span><span></span>
          </button>
        </div>
      </div>

      {open && (
        <div className="ds-nav__mobile">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              className="ds-navlink"
              onClick={() => setOpen(false)}
            >
              {l.label}
            </NavLink>
          ))}
          {isLoggedIn && (
            <NavLink className="ds-navlink" to={`/deposit`} onClick={() => setOpen(false)}>
              {t("overview.deposit")} · ${amount}
            </NavLink>
          )}
        </div>
      )}
    </nav>
  );
};

export default NavBar;
